export default {
  props: {
    slug: String,
    options: Array,
    related: {
      type: String,
      default: "to",
    },
    label: String,
    activeFilters: {
      type: Array,
      default: function() {
        return [];
      },
    },
    name: String,
  },
  data: function() {
    return {
      current: null,
    };
  },
  methods: {
    onChange: function(value) {
      this.$emit("onSelectionChanged", {
        related: this.related,
        prev: this.current,
        next: value,
      });
      this.current = value;
    },
  },
  template: `
      <div class="fancy_select">
        <select :name="name" @change="onChange($event.target.value)">
          <option :label="label">{{ label }}</option>
          <option
            v-for="option in options"
            :value="option.id"
            :selected="activeFilters.includes(option.value) || option.selected"
          >
            {{ option.title }}
          </option>
        </select>
      </div>
    `,
};
